const selectedDocumentAction = (document) => {
    return {
        type: 'STORE_DOCUMENT',
        payload: document,
    }
}

export default selectedDocumentAction
